// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__1HwEE","App-logo":"app_App-logo__4UY9m","App-logo-spin":"app_App-logo-spin__1ibk6","App-header":"app_App-header__3PFPD","App-link":"app_App-link__ue9Sn"};